import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UIModule } from './ui/ui.module';
import { HasPermissionDirective } from './directives/has-permission.directive';


@NgModule({
  declarations: [
    HasPermissionDirective
  ],
  imports: [
    CommonModule,
    UIModule,
  ],
  exports: [
    HasPermissionDirective
  ]
})

export class SharedModule { }
